<div class="content-header flex-c a-center">
    <div class="font--headline">{{ I18nKeyEnum.SMART_ASSISTANT_SETUP | i18n | async }}</div>
</div>

<mat-expansion-panel hideToggle expanded class="m-bottom-big">
    <div class="flex-r">
        <div class="flex-c m-top-mid m-bottom-mid">
            <div class="font--bold m-bottom-mid m-top-big">{{ I18nKeyEnum.ANALYSE_YOUR_WEBSITE | i18n | async }}</div>
            <div class="font--bold m-left-big m-bottom-mid m-top-mid">{{ user?.baseData?.website }}</div>
        </div>
        <mat-icon class="success big" [ngClass]="{'hidden': !categoryDone.knowledgeBase}"
                  [svgIcon]="ICONS.IC_CHECK"></mat-icon>
    </div>
    <mat-progress-bar class="m-bottom-big m-top-mid" mode="determinate"
                      [value]="websiteCrawlingStatus"></mat-progress-bar>
</mat-expansion-panel>

<mat-accordion>
    <mat-expansion-panel [expanded]="categoryOpenState.general" (opened)="categoryOpenState.general = true"
                         (closed)="categoryOpenState.general = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="panel-title" *ngIf="!categoryOpenState.general">
                    <div class="reserved-place">
                        <mat-icon class="success" [svgIcon]="ICONS.IC_CHECK"
                                  [ngClass]="{'hide' : !categoryDone.general}"></mat-icon>
                        <div class="not-filled"
                             [ngClass]="{'hide' : categoryDone.general}"></div>
                    </div>
                    <div>{{ I18nKeyEnum.SETUP_SMART_ASSISTANT | i18n | async }}</div>
                </div>
                <div class='font--bold m-bottom-mid m-top-big'
                     *ngIf="categoryOpenState.general">{{ I18nKeyEnum.GENERAL_SETTINGS_INFO | i18n | async }}
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-container *ngIf="(voiceBotTypes |
                        filterVoiceBotType :
                        voiceBotLanguageCtrl.value :
                        voiceBotGenderCtrl.value :
                        voiceBotAgeCtrl.value) as visibleVoiceBotTypes">
            <form class="flex-c"
                  [formGroup]='userAccountFormGroup'>
                <mat-form-field class="small space-between">
                    <mat-label>{{ I18nKeyEnum.GREETING | i18n | async }}</mat-label>
                    <input [required]="true"
                           [formControl]="greetingCtrl"
                           matInput>
                    <mat-error
                        *ngIf="greetingCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                    > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                    </mat-error>
                </mat-form-field>

                <mat-form-field class="small space-between">
                    <mat-label>{{ I18nKeyEnum.SELECT_VOICE_BOT_LANGUAGE | i18n | async }}</mat-label>
                    <mat-select
                        id="selectedLanguage"
                        [required]="true"
                        [formControl]="voiceBotLanguageCtrl">
                        <mat-select-trigger>
                            <div class="option-wrapper">
                                {{ !!voiceBotLanguageCtrl.value ? (voiceBotLanguageCtrl.value.i18nKey | i18n | async) : '' }}
                            </div>
                        </mat-select-trigger>
                        @for (voiceBotLanguage of voiceBotLanguages; track voiceBotLanguage) {
                            <mat-option [value]="voiceBotLanguage">
                                <div>{{ voiceBotLanguage.i18nKey | i18n | async }}</div>
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error
                        *ngIf="voiceBotLanguageCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                    >{{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="small space-between">
                    <mat-label>{{ I18nKeyEnum.SELECT_VOICE_BOT_GENDER | i18n | async }}</mat-label>
                    <mat-select
                        id="selectedGender"
                        [required]="true"
                        [formControl]="voiceBotGenderCtrl">
                        <mat-select-trigger>
                            <div class="option-wrapper">
                                {{ !!voiceBotGenderCtrl.value ? (voiceBotGenderCtrl.value.i18nKey | i18n | async) : '' }}
                            </div>
                        </mat-select-trigger>
                        @for (voiceBotGender of voiceBotGenders; track voiceBotGender) {
                            <mat-option [value]="voiceBotGender">
                                <div>{{ voiceBotGender.i18nKey | i18n | async }}</div>
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error
                        *ngIf="voiceBotGenderCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                    >{{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="small space-between">
                    <mat-label>{{ I18nKeyEnum.SELECT_VOICE_BOT_AGE | i18n | async }}</mat-label>
                    <mat-select
                        id="selectedAge"
                        [required]="true"
                        [formControl]="voiceBotAgeCtrl">
                        <mat-select-trigger>
                            <div class="option-wrapper">
                                {{ !!voiceBotAgeCtrl.value ? (voiceBotAgeCtrl.value.i18nKey | i18n | async) : '' }}
                            </div>
                        </mat-select-trigger>
                        @for (voiceBotAge of voiceBotAges; track voiceBotAge) {
                            <mat-option [value]="voiceBotAge">
                                <div>{{ voiceBotAge.i18nKey | i18n | async }}</div>
                            </mat-option>
                        }
                    </mat-select>
                    <mat-error
                        *ngIf="voiceBotAgeCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                    >{{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                    </mat-error>
                </mat-form-field>
                <div class="ct-voice-bot-type">
                    <mat-label>{{ I18nKeyEnum.VOICE_BOT_TYPE | i18n | async }}</mat-label>
                    <mat-spinner *ngIf="!voiceBotTypes?.length"
                                 [diameter]="24"></mat-spinner>
                    <div *ngIf="!!visibleVoiceBotTypes?.length"
                         class="ct-voice-bot-type-content">
                        <div class="ct-voice-bot-type-selection">
                            <mat-radio-group [formControl]="voiceBotTypeCtrl">
                                <ng-container>
                                    @for (voiceBotType of visibleVoiceBotTypes; track voiceBotType; let index = $index) {
                                        <mat-radio-button [value]="voiceBotType"
                                                          [checked]="index === 0">
                                            {{ voiceBotType.name }}
                                        </mat-radio-button>
                                    }
                                </ng-container>
                            </mat-radio-group>
                        </div>
                        <div class="ct-voice-bot-audio">
                            @for (voiceBotType of visibleVoiceBotTypes; track voiceBotType) {
                                <div class="ct-voice-bot-type-details">
                                    <div class="ct-voice-bot-type-description">({{ voiceBotType.labels.language | i18nVoiceBotLanguage | async }}, {{ voiceBotType.labels.gender | i18nVoiceBotGender | async }}, {{ voiceBotType.labels.age | i18nVoiceBotAge | async }})</div>
                                    <div class="ct-voice-bot-audio-playback">
                                        <button mat-icon-button
                                                *ngIf="voiceBotType?.preview_url"
                                                (click)="playAudio(voiceBotType)">
                                            <mat-icon [svgIcon]="ICONS.IC_PLAY"></mat-icon>
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div *ngIf="!visibleVoiceBotTypes?.length"
                         class="ct-voice-assistant-not-available">{{ I18nKeyEnum.VOICE_ASSISTANT_NOT_AVAILABLE | i18n | async }}
                    </div>
                </div>
            </form>
            <div class="flex-r center">
                <button mat-flat-button class="button-base"
                        (click)="saveGeneralSettings()"
                        [disabled]="!visibleVoiceBotTypes?.length || inProgress.accountCreation">{{ I18nKeyEnum.SAVE | i18n | async }}
                </button>
            </div>
        </ng-container>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="categoryOpenState.callScenarios" (opened)="categoryOpenState.callScenarios = true"
                         (closed)="categoryOpenState.callScenarios = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="panel-title" *ngIf="!categoryOpenState.callScenarios">
                    <div class="reserved-place">
                        <mat-icon class="success" [svgIcon]="ICONS.IC_CHECK"
                                  [ngClass]="{'hide' : !categoryDone.callScenarios}"></mat-icon>
                        <div class="not-filled"
                             [ngClass]="{'hide' : categoryDone.callScenarios}"></div>
                    </div>
                    <div>{{ I18nKeyEnum.CALL_SCENARIO_TITLE | i18n | async }}</div>
                </div>
                <div class='font--bold m-bottom-mid m-top-big'
                     *ngIf="categoryOpenState.callScenarios">{{ I18nKeyEnum.CALL_SCENARIO_INFO | i18n | async }}
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="m-bottom-big call-scenarios" *ngIf="!!callScenarios && callScenarios.length > 0">
            <div class="font--small m-bottom-mid">{{ I18nKeyEnum.CALL_SCENARIOS | i18n | async }}</div>
            <mat-accordion>
                <mat-expansion-panel *ngFor="let callScenario of callScenarios; index as i;">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ callScenario.function_definition.display_name }}
                            <div class="delete-icon" [ngClass]="{'inactive': inProgress.callReasonAdjustment || inProgress.callReasonCreation}" (click)="deleteCallScenario(callScenario)">
                                <mat-icon [svgIcon]="ICONS.IC_DELETE"></mat-icon>
                            </div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="font--small m-bottom-mid">{{ callScenario.function_definition.description }}</div>
                    <div class="flex-c p-mid m-bottom-mid" style="border:1px solid grey;"
                         *ngFor="let property of callScenario.function_definition.parameters.properties; index as i;">
                        <div class="flex-r">
                            <div class="font--small-bold">{{ property.display_name }}</div>
                            <div class="delete-icon" [ngClass]="{'inactive': inProgress.callReasonAdjustment || inProgress.callReasonCreation}" (click)="deletePropertyScenario(callScenario, property.name)">
                                <mat-icon [svgIcon]="ICONS.IC_DELETE"></mat-icon>
                            </div>
                        </div>
                        <div class="font--small m-left-mid">{{ property.description }}</div>
                    </div>
                    <div>
                        <form class="flex-c" [formGroup]='addPropertyFormGroup' #callScenarioPropertyForm="ngForm">
                            <div class="font--small m-bottom-mid">{{ I18nKeyEnum.ADD_PROPERTY | i18n | async }}</div>
                            <div class="font--small-error" *ngIf="callScenarioCtrl.hasError(validatorsErrorEnum.EQUAL)"
                            > {{ I18nKeyEnum.ERROR_PARAPHRASE_DETAIL | i18n | async }}</div>
                            <mat-form-field *ngIf="!inProgress.callReasonAdjustment">
                                <textarea matInput [required]="true" [formControl]="PropertyCtrl"
                                          [placeholder]="(I18nKeyEnum.DESCRIBE_PROPERTY | i18n | async) || ''"
                                          [rows]="2"></textarea>
                                <mat-error
                                        *ngIf="callScenarioCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                                > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                                </mat-error>
                            </mat-form-field>
                            <div class="flex-r center" *ngIf="inProgress.callReasonAdjustment">
                                <mat-spinner [diameter]="24"></mat-spinner>
                            </div>
                            <div class="flex-r center">
                                <button mat-flat-button class="button-base"
                                        [disabled]="inProgress.callReasonAdjustment || inProgress.callReasonCreation"
                                        (click)="addProperty(callScenario,PropertyCtrl.value, callScenarioCtrl)">{{ I18nKeyEnum.SAVE | i18n | async }}
                                </button>
                            </div>
                        </form>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
        <div>
            <div class="font m-bottom-big m-top-big">{{ I18nKeyEnum.CREATE_CALL_SCENARIO | i18n | async }}</div>
            <form class="flex-c" [formGroup]='callScenarioFormGroup' #callScenarioForm="ngForm">
                <div class="font--small m-bottom-mid">{{ I18nKeyEnum.DESCRIBE_CALL_SCENARIO | i18n | async }}</div>
                <mat-form-field [floatLabel]="'always'"  *ngIf="!inProgress.callReasonCreation">
                    <mat-label>{{ I18nKeyEnum.CALL_SCENARIO | i18n | async }}</mat-label>
                    <textarea
                            matInput [required]="true" [formControl]="callScenarioCtrl"
                              [placeholder]="callScenarioExample"
                              [rows]="2"></textarea>
                    <mat-error
                            *ngIf="callScenarioCtrl.hasError(validatorsErrorEnum.REQUIRED)"
                    > {{ I18nKeyEnum.ERROR_REQUIRED | i18n | async }}
                    </mat-error>
                </mat-form-field>
                <div class="flex-r center" *ngIf="inProgress.callReasonCreation">
                    <mat-spinner [diameter]="24"></mat-spinner>
                </div>
                <div class="flex-r center">
                    <button mat-flat-button class="button-base" [disabled]="inProgress.callReasonCreation || inProgress.accountCreation || inProgress.callReasonAdjustment"
                            (click)="saveCallScenario()">{{ I18nKeyEnum.SAVE | i18n | async }}
                    </button>
                </div>
            </form>
        </div>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="categoryOpenState.knowledgeBase" (opened)="categoryOpenState.knowledgeBase = true"
                         (closed)="categoryOpenState.knowledgeBase = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <div class="panel-title" *ngIf="!categoryOpenState.knowledgeBase">
                    <div class="reserved-place">
                        <mat-icon class="success" [svgIcon]="ICONS.IC_CHECK"
                                  [ngClass]="{'hide' : !summary}"></mat-icon>
                        <div class="not-filled"
                             [ngClass]="{'hide' : !!summary}"></div>
                    </div>
                    <div>{{ I18nKeyEnum.KNOWLEDGE_BASE_TITLE | i18n | async }}</div>
                </div>
                <div class='font--bold m-bottom-mid m-top-big'
                     *ngIf="categoryOpenState.knowledgeBase">{{ I18nKeyEnum.KNOWLEDGE_BASE_INFO| i18n | async }}
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="knowledge-base-info">{{ I18nKeyEnum.KNOWLEDGE_BASE_INTRO | i18n | async }}</div>
        <div class="knowledge-base-separator" *ngIf="!!summary">
            <div class="collapse-action-bar"  [ngClass]="{'hidden': !summary}">
                <div class="action-btn" (click)="accordion.openAll()" [matTooltip]="(I18nKeyEnum.EXPAND_ALL | i18n | async)">
                    <mat-icon [svgIcon]="ICONS.IC_EXPAND_ALL"></mat-icon>
                </div>
                <div class="action-btn" (click)="accordion.closeAll()"  [matTooltip]="(I18nKeyEnum.COLLAPSE_ALL | i18n | async)">
                    <mat-icon [svgIcon]="ICONS.IC_COLLAPSE_ALL"></mat-icon>
                </div>
            </div>
            <mat-accordion #accordion="matAccordion" [multi]="true">
                <mat-expansion-panel *ngFor="let entry of summary; index as i;">
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ entry.title }}</mat-panel-title>
                    </mat-expansion-panel-header>

                    <div class="collapse-action-bar">
                        <div class="action-btn" (click)="subAccordion.openAll()" [matTooltip]="(I18nKeyEnum.EXPAND_ALL | i18n | async)">
                            <mat-icon [svgIcon]="ICONS.IC_EXPAND_ALL"></mat-icon>
                        </div>
                        <div class="action-btn" (click)="subAccordion.closeAll()" [matTooltip]="(I18nKeyEnum.COLLAPSE_ALL | i18n | async)">
                            <mat-icon [svgIcon]="ICONS.IC_COLLAPSE_ALL"></mat-icon>
                        </div>
                    </div>
                    <mat-accordion #subAccordion="matAccordion" [multi]="true">
                        <mat-expansion-panel *ngFor="let subEntry of entry.subtitles; index as i;">
                            <mat-expansion-panel-header>
                                <mat-panel-title>{{ subEntry.subtitle }}</mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="knowledge-base-content">{{ subEntry.content }}</div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-expansion-panel>
</mat-accordion>

